import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/EmployeeReqs/EmployeeReqs';

function* getEmployeesList(action) {
    try {
        const result = yield call(req.getEmployeesListReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_EMPLOYEES_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEES_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEES_LIST_FAILURE, message: e?.message });
    }
}

function* getEmployeeDetails(action) {
    try {
        const result = yield call(req.getEmployeeDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEE_DETAILS_FAILURE, message: e?.message });
    }
}

// Failure detail for the onError callbacks. Employee writes reach here two
// ways — the request layer catches and returns the axios error, or it throws —
// and both carry the envelope at `response.data`. `code` is null for plain
// employee errors; it is populated when the failure came from the shift half
// of the request (see employeeShiftFields.isPartialShiftFailure).
const errorInfo = (e) => {
    const envelope = e?.response?.data;
    return {
        message: envelope?.message || e?.message || 'Something went wrong',
        code: envelope?.data?.code || null,
        data: envelope?.data || null,
    };
};

function* createEmployee(action) {
    try {
        const result = yield call(req.createEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CREATE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            // The request layer catches and RETURNS the axios error, so a
            // failure arrives here as a value, not a throw.
            const info = errorInfo(result);
            yield put({ type: types.SOCIETY_CREATE_EMPLOYEE_FAILURE, message: info.message });
            action.data?.onError?.(info);
        }
    } catch (e) {
        const info = errorInfo(e);
        yield put({ type: types.SOCIETY_CREATE_EMPLOYEE_FAILURE, message: info.message });
        action.data?.onError?.(info);
    }
}

function* updateEmployee(action) {
    try {
        const result = yield call(req.updateEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            const info = errorInfo(result);
            yield put({ type: types.SOCIETY_UPDATE_EMPLOYEE_FAILURE, message: info.message });
            action.data?.onError?.(info);
        }
    } catch (e) {
        const info = errorInfo(e);
        yield put({ type: types.SOCIETY_UPDATE_EMPLOYEE_FAILURE, message: info.message });
        action.data?.onError?.(info);
    }
}

function* deleteEmployee(action) {
    try {
        const result = yield call(req.deleteEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_EMPLOYEE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* getEmployeeTypes(action) {
    try {
        const result = yield call(req.getEmployeeTypesReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_TYPES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_TYPES_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEE_TYPES_FAILURE, message: e?.message });
    }
}

function* getCountriesDropdown(action) {
    try {
        const result = yield call(req.getCountriesDropdownReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_COUNTRIES_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COUNTRIES_DROPDOWN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_COUNTRIES_DROPDOWN_FAILURE, message: e?.message });
    }
}

function* getEmployeeAuditLog(action) {
    try {
        const result = yield call(req.getEmployeeAuditLogReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_FAILURE, message: e?.message });
    }
}

function* searchEmployeeByEmail(action) {
    try {
        const result = yield call(req.searchEmployeeByEmailReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE, message: e?.message });
    }
}

function* linkExistingEmployee(action) {
    try {
        const result = yield call(req.linkExistingEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_LINK_EXISTING_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_LINK_EXISTING_EMPLOYEE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_LINK_EXISTING_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* getUsernamesDropdown(action) {
    try {
        const result = yield call(req.getUsernamesDropdownReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_USERNAMES_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_USERNAMES_DROPDOWN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_USERNAMES_DROPDOWN_FAILURE, message: e?.message });
    }
}

function* getEmployeesDropdown(action) {
    try {
        const result = yield call(req.getEmployeesDropdownReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_EMPLOYEES_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_EMPLOYEES_DROPDOWN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_EMPLOYEES_DROPDOWN_FAILURE, message: e?.message });
    }
}

export default function* EmployeeSaga() {
    yield takeLatest(types.SOCIETY_GET_EMPLOYEES_LIST, getEmployeesList);
    yield takeLatest(types.SOCIETY_GET_EMPLOYEE_DETAILS, getEmployeeDetails);
    yield takeLatest(types.SOCIETY_CREATE_EMPLOYEE, createEmployee);
    yield takeLatest(types.SOCIETY_UPDATE_EMPLOYEE, updateEmployee);
    yield takeLatest(types.SOCIETY_DELETE_EMPLOYEE, deleteEmployee);
    yield takeLatest(types.SOCIETY_GET_EMPLOYEE_TYPES, getEmployeeTypes);
    yield takeLatest(types.SOCIETY_GET_COUNTRIES_DROPDOWN, getCountriesDropdown);
    yield takeLatest(types.SOCIETY_GET_EMPLOYEE_AUDIT_LOG, getEmployeeAuditLog);
    yield takeLatest(types.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL, searchEmployeeByEmail);
    yield takeLatest(types.SOCIETY_LINK_EXISTING_EMPLOYEE, linkExistingEmployee);
    yield takeLatest(types.SOCIETY_GET_USERNAMES_DROPDOWN, getUsernamesDropdown);
    yield takeLatest(types.SOCIETY_GET_EMPLOYEES_DROPDOWN, getEmployeesDropdown);
}
